import { render, staticRenderFns } from "./BeneficioList.vue?vue&type=template&id=2e54565d&scoped=true&"
import script from "./BeneficioList.vue?vue&type=script&lang=js&"
export * from "./BeneficioList.vue?vue&type=script&lang=js&"
import style0 from "./BeneficioList.vue?vue&type=style&index=0&id=2e54565d&lang=scss&scoped=true&"
import style1 from "./BeneficioList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e54565d",
  null
  
)

export default component.exports